/**
 * @Description 打靶任务API
 */
import { post } from '@/common/request/index';

/**
 * 打靶任务导出
 * https://yapi.lanhanba.com/project/532/interface/api/85056
 */

export function exportPractice(params: any) {
  return post('/standard/checkIn/taskPageExport', { ...(params || {}) }, true);
}

/**
 * 打靶任务分页列表
 * https://yapi.lanhanba.com/project/532/interface/api/84671
 */

export function practicePageList(params: any) {
  return post('/standard/checkIn/taskPage', { ...(params || {}) }, true);
}

/**
 * 打靶任务删除
 * https://yapi.lanhanba.com/project/532/interface/api/85049
 */

export function deletePractice(params: any) {
  return post('/standard/checkIn/deleteTask', { ...(params || {}) }, true);
}

/**
 * 打靶任务详情
 * https://yapi.lanhanba.com/project/532/interface/api/84678
 */

export function practiceDetail(params: any) {
  return post('/standard/checkIn/taskDetail', { ...(params || {}) }, true);
}

/**
 * 打靶任务编辑
 * https://yapi.lanhanba.com/project/532/interface/api/84664
 */

export function practiceEdit(params: any) {
  return post('/standard/checkIn/editTask', { ...(params || {}) }, true);
}

/**
 * 打卡记录分页
 * https://yapi.lanhanba.com/project/532/interface/api/84685
 */

export function checkInRecordPage(params: any) {
  return post('/standard/checkIn/recordPage', { ...(params || {}) }, true);
}

/**
 * 打卡记录导出-限定1w
 * https://yapi.lanhanba.com/project/532/interface/api/85063
 */
export function checkInRecordPageExport(params: any) {
  return post('/standard/checkIn/recordPageExport', { ...(params || {}) }, true);
}
